import React from "react";
import ChecklistCatalog from "../../components/checklist/ChecklistCatalog";

export default function OtherChecklist() {
  return <ChecklistCatalog type="other" />;
}
